import { render, staticRenderFns } from "./ModelOfDeliveryDetail.vue?vue&type=template&id=2e426f4e&"
import script from "./ModelOfDeliveryDetail.vue?vue&type=script&lang=js&"
export * from "./ModelOfDeliveryDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports